import { Component, Input, AfterViewInit, ViewChild, ViewEncapsulation, ElementRef, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'svg-qrcode',
    templateUrl: './svg-qrcode.component.html',
    styleUrls: ['./svg-qrcode.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class SvgQrcodeComponent implements OnInit, AfterViewInit {

    @ViewChild("qrContainer", { static: true }) container: ElementRef<HTMLDivElement>;

    @Input('url') set setUrl(url: string) {
        this.url = url;
        this.updateQrCode();
    }

    // Including the StoryHunt logo in the qr increases the generating time significantly
    @Input() includeLogo: boolean = true;

    private static readonly QR_SIZE = 400;
    private viewInitialized: boolean = false;
    private url = 'https://storyhunt.dk';
    private qrCodeStyling = null;
    private qrCode = null;

    constructor() {
    }

    ngOnInit(): void {
        if(typeof window === 'undefined') return;
        this.qrCodeStyling = require("qr-code-styling");
    }

    ngAfterViewInit(): void {
        this.viewInitialized = true;
        this.updateQrCode();
    }

    private updateQrCode() {
        if(!this.viewInitialized || !this.qrCodeStyling) return;

        // Generate qr code with styling options
        // Find more styling options on https://qr-code-styling.com/
        // And style examples here: https://reactjsexample.com/javascript-library-for-generating-qr-codes-with-a-logo-and-styling
        this.qrCode = new this.qrCodeStyling({
            width: SvgQrcodeComponent.QR_SIZE,
            height: SvgQrcodeComponent.QR_SIZE,
            margin: 5,
            data: this.url,
            image: this.includeLogo ? "https://firebasestorage.googleapis.com/v0/b/motesdev.appspot.com/o/static-images%2Fstoryhunt_logo_clean_dark.png?alt=media&token=11a8cebe-4b47-48d1-bdfe-fd515dfa826e" : null,
            qrOptions: {
                "mode": "Byte",
                "errorCorrectionLevel": "H"
            },
            dotsOptions: {
                color: "#222222",
                type: "square"
            },
            cornersDotOptions: {
                type: "square",
                color: "#222222"
            },
            backgroundOptions: {
                color: "#ffffff"
            },
            cornersSquareOptions: {
                type: "square",
                color: "#222222"
            },
            imageOptions: {
                crossOrigin: "anonymous",
                hideBackgroundDots: true,
                margin: 0,
                imageSize: 0.1
            }
        });

        // Clear qr container and add canvas
        if(this.container.nativeElement.hasChildNodes()) this.container.nativeElement.removeChild(this.container.nativeElement.firstChild);
        this.qrCode.append(this.container.nativeElement);
    }

    public getQrCodeBlob(): Promise<Blob> {
        if(!this.qrCodeStyling) return;

        return this.qrCode.getRawData('png');
    }
}


